import React, { lazy, Suspense } from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import { connect } from 'react-redux'

import Layout from 'layouts'

const routes = [
  {
    path: '/dashboard/profiles',
    Component: lazy(() => import('pages/dashboard/profiles')),
    exact: true,
  },
  {
    path: '/dashboard/demo-users',
    Component: lazy(() => import('pages/dashboard/demo-users')),
    exact: true,
  },
  {
    path: '/dashboard/demo-users/new',
    Component: lazy(() => import('pages/dashboard/demo-users/new')),
    exact: true,
  },
  {
    path: '/dashboard/demo-users/:id',
    Component: lazy(() => import('pages/dashboard/demo-users/profile')),
    exact: true,
  },
  {
    path: '/dashboard/benefits',
    Component: lazy(() => import('pages/dashboard/benefits')),
    exact: true,
  },
  {
    path: '/dashboard/workspace',
    Component: lazy(() => import('pages/dashboard/workspace')),
    exact: true,
  },
  {
    path: '/dashboard/invite',
    Component: lazy(() => import('pages/dashboard/invite')),
    exact: true,
  },
  {
    path: '/dashboard/profiles/:id',
    Component: lazy(() => import('pages/dashboard/profiles/profile')),
    exact: true,
  },
  {
    path: '/dashboard/my-workflows/profiles/:profileId/workflows/:workflowId',
    Component: lazy(() => import('pages/dashboard/my-workflows/index')),
    exact: true,
  },
  {
    path: '/dashboard/profile/new',
    Component: lazy(() => import('pages/dashboard/profiles/new')),
    exact: true,
  },
  {
    path: '/dashboard/onboarding',
    Component: lazy(() => import('pages/dashboard/onboarding')),
    exact: true,
  },
  {
    path: '/dashboard/browsertesting',
    Component: lazy(() => import('pages/dashboard/browsertesting')),
    exact: true,
  },
  {
    path: '/dashboard/workflows',
    Component: lazy(() => import('pages/dashboard/workflows')),
    exact: true,
  },
  {
    path: '/dashboard/progress',
    Component: lazy(() => import('pages/dashboard/progress')),
    exact: true,
  },
  {
    path: '/dashboard/details',
    Component: lazy(() => import('pages/dashboard/details')),
    exact: true,
  },
  {
    path: '/dashboard/cars-calculator',
    Component: lazy(() => import('pages/dashboard/salpac-calculator')),
    exact: true,
  },
  {
    path: '/dashboard/chattel-calculator',
    Component: lazy(() => import('pages/dashboard/chattel-calculator')),
    exact: true,
  },
  {
    path: '/dashboard/promoted-benefits',
    Component: lazy(() => import('pages/dashboard/promoted-benefits')),
    exact: true,
  },
  {
    path: '/dashboard/theming',
    Component: lazy(() => import('pages/dashboard/theming')),
    exact: true,
  },

  // Auth Pages
  {
    path: '/auth/login',
    Component: lazy(() => import('pages/auth/login')),
    exact: true,
  },
  {
    path: '/auth/email-login',
    Component: lazy(() => import('pages/auth/email-login')),
    exact: true,
  },
  {
    path: '/auth/forgot-password',
    Component: lazy(() => import('pages/auth/forgot-password')),
    exact: true,
  },
  {
    path: '/auth/register',
    Component: lazy(() => import('pages/auth/register')),
    exact: true,
  },
  {
    path: '/auth/lockscreen',
    Component: lazy(() => import('pages/auth/lockscreen')),
    exact: true,
  },
  {
    path: '/auth/404',
    Component: lazy(() => import('pages/auth/404')),
    exact: true,
  },
  {
    path: '/auth/500',
    Component: lazy(() => import('pages/auth/500')),
    exact: true,
  },
]

const mapStateToProps = ({ settings }) => ({
  routerAnimation: settings.routerAnimation,
})

const Router = ({ history, routerAnimation }) => {
  return (
    <ConnectedRouter history={history}>
      <Layout>
        <Route
          render={state => {
            const { location } = state
            return (
              <SwitchTransition>
                <CSSTransition
                  key={location.pathname}
                  appear
                  classNames={routerAnimation}
                  timeout={routerAnimation === 'none' ? 0 : 300}
                >
                  <Switch location={location}>
                    <Route exact path="/" render={() => <Redirect to="/dashboard/onboarding" />} />
                    {routes.map(({ path, Component, exact }) => (
                      <Route
                        path={path}
                        key={path}
                        exact={exact}
                        render={() => {
                          return (
                            <div className={routerAnimation}>
                              <Suspense fallback={null}>
                                <Component />
                              </Suspense>
                            </div>
                          )
                        }}
                      />
                    ))}
                    <Redirect to="/auth/404" />
                  </Switch>
                </CSSTransition>
              </SwitchTransition>
            )
          }}
        />
      </Layout>
    </ConnectedRouter>
  )
}

export default connect(mapStateToProps)(Router)
